import { create } from "zustand";
import type { User } from "@/types";
import { clearMenuCache } from "@/store/menu-store";

/**
 * 이 브라우저에 남아 있는 "앞사람 흔적" 을 모두 지운다 (2026-10-14).
 *
 * 한 PC 에서 계정을 바꿔 로그인하면 앞사람의 메뉴·탭이 새 계정 화면에 섞여 보였다.
 * 로그아웃할 때도, 새로 로그인할 때도 부른다 — 로그아웃 없이 창을 닫고 다른 계정으로
 * 들어오는 경우가 더 흔하기 때문이다.
 */
export function clearSessionTraces() {
  clearMenuCache();                                   // 메뉴(권한) 캐시
  try { sessionStorage.removeItem("fito-tab-store"); } catch { /* 저장소가 막힌 브라우저 */ }
}

interface AuthState {
  user: User | null;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  logout: () => Promise<void>;
  fetchUser: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,

  setUser: (user) => set({ user, isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),

  logout: async () => {
    await fetch("/api/auth/logout", { method: "POST" });
    set({ user: null });
    // 이 사람이 쓰던 흔적을 모두 비운다 — 다음 사람에게 넘어가지 않게 (2026-10-07, 2026-10-14)
    clearSessionTraces();
    window.location.href = "/login";
  },

  fetchUser: async () => {
    try {
      const res = await fetch("/api/auth/me");
      if (res.ok) {
        const data = await res.json();
        set({ user: data.user, isLoading: false });
      } else {
        set({ user: null, isLoading: false });
      }
    } catch {
      set({ user: null, isLoading: false });
    }
  },
}));
